import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import "./VisitorStats.css";

const COUNTER_NAMESPACE = "daymusic-melbourne";
const COUNTER_KEY = "site-visits";
const SESSION_FLAG = "daymusic-visit-counted";

// `d=` parameter from the ClustrMaps embed script.
const CLUSTRMAPS_WIDGET_ID = "2-Bo2x_Hp3oHxsBUYL-JtUCHX9Gvd_APVM6DzaQ-3k4";

const mapIframeSrcDoc = `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<style>
  html, body { margin: 0; padding: 0; background: transparent; overflow: hidden; }
  body { display: flex; justify-content: center; }
</style>
</head>
<body>
<script type="text/javascript" id="clustrmaps" src="//clustrmaps.com/map_v2.js?d=${CLUSTRMAPS_WIDGET_ID}&cl=ffffff&w=a"></script>
</body>
</html>`;

function buildCounterUrl(alreadyCounted) {
  const action = alreadyCounted ? "get" : "hit";
  return `https://abacus.jasoncameron.dev/${action}/${COUNTER_NAMESPACE}/${COUNTER_KEY}`;
}

export default function VisitorStats() {
  const { t } = useLanguage();
  const [count, setCount] = useState(null);
  const [counterFailed, setCounterFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const alreadyCounted = sessionStorage.getItem(SESSION_FLAG) === "1";

    fetch(buildCounterUrl(alreadyCounted))
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Counter request failed: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (cancelled) return;
        const next = typeof data?.value === "number" ? data.value : null;
        setCount(next);
        if (!alreadyCounted) {
          sessionStorage.setItem(SESSION_FLAG, "1");
        }
      })
      .catch(() => {
        if (cancelled) return;
        setCounterFailed(true);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const displayCount =
    counterFailed ? "—" : count === null ? "···" : count.toLocaleString();

  return (
    <section className="visitor-stats" aria-label={t.footer.visitorsTitle}>
      <div className="visitor-count" role="status" aria-live="polite">
        <span className="count-label">{t.footer.visitorsLabel}</span>
        <span className="count-value">{displayCount}</span>
      </div>
      <div className="visitor-map-wrap">
        <p className="visitor-map-title">{t.footer.mapTitle}</p>
        {CLUSTRMAPS_WIDGET_ID ? (
          <iframe
            className="visitor-map-frame"
            title={t.footer.mapTitle}
            srcDoc={mapIframeSrcDoc}
            sandbox="allow-scripts allow-same-origin allow-popups"
            loading="lazy"
          />
        ) : (
          <div className="visitor-map">
            <p className="visitor-map-placeholder">
              {t.footer.mapPlaceholder}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
